import {makeAutoObservable} from "mobx";

class SelectOrderAddressStore {
    list = [];
    id = 0;

    constructor() {
        makeAutoObservable(this)
    }

    get currentAddress() {
        if (!this.id) {
            return null;
        }

        return this.list.find(item => item.id === this.id);
    }

}

const store = new SelectOrderAddressStore()

export default store
